class RegisterForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
  }

  connectedCallback() {
    if (!this.form) return;
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    this.querySelector('[data-tag="phone"]')?.addEventListener('change', (e) => {
      const val = e.target.value?.trim();
      this.querySelector('[data-tag="phone_prefix"]')?.toggleAttribute('required', !!val);
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const tags = ['newsletter'];

    const titleVal = this.form.querySelector('[data-tag="title"]')?.value;
    if (titleVal) {
      tags.push(`title_${titleVal}`);
      this.form.querySelector('#register-meta-title').value = titleVal;
    }

    const firstName = this.form.querySelector('[data-tag="first-name"]')?.value?.trim();
    if (firstName) tags.push(`first-name_${firstName}`);

    const lastName = this.form.querySelector('[data-tag="last-name"]')?.value?.trim();
    if (lastName) tags.push(`last-name_${lastName}`);

    const birthdate = this.form.querySelector('[data-tag="birthdate"]')?.value;
    if (birthdate) {
      tags.push(`birthdate_${birthdate}`);
      this.form.querySelector('#register-meta-birth-date').value = birthdate;
    }

    const phonePrefix = this.form.querySelector('[data-tag="phone_prefix"]')?.value?.trim();
    const phone = this.form.querySelector('[data-tag="phone"]')?.value?.trim();
    if (phonePrefix) tags.push(`prefix_${phonePrefix}`);
    if (phone) tags.push(`phone_${phone}`);

    const countryEl = this.form.querySelector('[data-tag="country"]');
    if (countryEl?.selectedIndex >= 0) {
      const iso2 = countryEl.options[countryEl.selectedIndex]?.value;
      const iso3 = this.toIsocode3(iso2);
      if (iso3) {
        tags.push(`country_${iso3}`);
        this.form.querySelector('#register-meta-country').value = iso3;
      }
    }

    const groupOptIn = this.form.querySelector('#register-group-opt-in')?.checked;
    this.form.querySelector('#register-meta-group-opt-in').value = groupOptIn ? 'true' : 'false';

    const profilingChecked = this.form.querySelector('[data-consent-tag="accept-profiling"]')?.checked;
    if (profilingChecked) {
      tags.push('accept-profiling');
      this.form.querySelector('#register-meta-privacy').value = 'accept-profiling';
    }

    this.form.querySelector('#register-tags').value = tags.join(',');
    this.form.submit();
  }

  toIsocode3(iso2) {
    return {
      AD:'AND',AE:'ARE',AF:'AFG',AG:'ATG',AI:'AIA',AL:'ALB',AM:'ARM',AO:'AGO',AQ:'ATA',AR:'ARG',
      AS:'ASM',AT:'AUT',AU:'AUS',AW:'ABW',AX:'ALA',AZ:'AZE',BA:'BIH',BB:'BRB',BD:'BGD',BE:'BEL',
      BF:'BFA',BG:'BGR',BH:'BHR',BI:'BDI',BJ:'BEN',BL:'BLM',BM:'BMU',BN:'BRN',BO:'BOL',BQ:'BES',
      BR:'BRA',BS:'BHS',BT:'BTN',BV:'BVT',BW:'BWA',BY:'BLR',BZ:'BLZ',CA:'CAN',CC:'CCK',CD:'COD',
      CF:'CAF',CG:'COG',CH:'CHE',CI:'CIV',CK:'COK',CL:'CHL',CM:'CMR',CN:'CHN',CO:'COL',CR:'CRI',
      CU:'CUB',CV:'CPV',CW:'CUW',CX:'CXR',CY:'CYP',CZ:'CZE',DE:'DEU',DJ:'DJI',DK:'DNK',DM:'DMA',
      DO:'DOM',DZ:'DZA',EC:'ECU',EE:'EST',EG:'EGY',EH:'ESH',ER:'ERI',ES:'ESP',ET:'ETH',FI:'FIN',
      FJ:'FJI',FK:'FLK',FM:'FSM',FO:'FRO',FR:'FRA',GA:'GAB',GB:'GBR',GD:'GRD',GE:'GEO',GF:'GUF',
      GG:'GGY',GH:'GHA',GI:'GIB',GL:'GRL',GM:'GMB',GN:'GIN',GP:'GLP',GQ:'GNQ',GR:'GRC',GS:'SGS',
      GT:'GTM',GU:'GUM',GW:'GNB',GY:'GUY',HK:'HKG',HM:'HMD',HN:'HND',HR:'HRV',HT:'HTI',HU:'HUN',
      ID:'IDN',IE:'IRL',IL:'ISR',IM:'IMN',IN:'IND',IO:'IOT',IQ:'IRQ',IR:'IRN',IS:'ISL',IT:'ITA',
      JE:'JEY',JM:'JAM',JO:'JOR',JP:'JPN',KE:'KEN',KG:'KGZ',KH:'KHM',KI:'KIR',KM:'COM',KN:'KNA',
      KP:'PRK',KR:'KOR',KW:'KWT',KY:'CYM',KZ:'KAZ',LA:'LAO',LB:'LBN',LC:'LCA',LI:'LIE',LK:'LKA',
      LR:'LBR',LS:'LSO',LT:'LTU',LU:'LUX',LV:'LVA',LY:'LBY',MA:'MAR',MC:'MCO',MD:'MDA',ME:'MNE',
      MF:'MAF',MG:'MDG',MH:'MHL',MK:'MKD',ML:'MLI',MM:'MMR',MN:'MNG',MO:'MAC',MP:'MNP',MQ:'MTQ',
      MR:'MRT',MS:'MSR',MT:'MLT',MU:'MUS',MV:'MDV',MW:'MWI',MX:'MEX',MY:'MYS',MZ:'MOZ',NA:'NAM',
      NC:'NCL',NE:'NER',NF:'NFK',NG:'NGA',NI:'NIC',NL:'NLD',NO:'NOR',NP:'NPL',NR:'NRU',NU:'NIU',
      NZ:'NZL',OM:'OMN',PA:'PAN',PE:'PER',PF:'PYF',PG:'PNG',PH:'PHL',PK:'PAK',PL:'POL',PM:'SPM',
      PN:'PCN',PR:'PRI',PS:'PSE',PT:'PRT',PW:'PLW',PY:'PRY',QA:'QAT',RE:'REU',RO:'ROU',RS:'SRB',
      RU:'RUS',RW:'RWA',SA:'SAU',SB:'SLB',SC:'SYC',SD:'SDN',SE:'SWE',SG:'SGP',SH:'SHN',SI:'SVN',
      SJ:'SJM',SK:'SVK',SL:'SLE',SM:'SMR',SN:'SEN',SO:'SOM',SR:'SUR',SS:'SSD',ST:'STP',SV:'SLV',
      SX:'SXM',SY:'SYR',SZ:'SWZ',TC:'TCA',TD:'TCD',TF:'ATF',TG:'TGO',TH:'THA',TJ:'TJK',TK:'TKL',
      TL:'TLS',TM:'TKM',TN:'TUN',TO:'TON',TR:'TUR',TT:'TTO',TV:'TUV',TW:'TWN',TZ:'TZA',UA:'UKR',
      UG:'UGA',UM:'UMI',US:'USA',UY:'URY',UZ:'UZB',VA:'VAT',VC:'VCT',VE:'VEN',VG:'VGB',VI:'VIR',
      VN:'VNM',VU:'VUT',WF:'WLF',WS:'WSM',YE:'YEM',YT:'MYT',ZA:'ZAF',ZM:'ZMB',ZW:'ZWE'
    }[iso2];
  }
}

if (!customElements.get('register-form')) {
  customElements.define('register-form', RegisterForm);
}